import styled from '@emotion/styled'

import { breakpoints, spacing } from 'main/ui'

export const LeftColumn = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
`

export const RightColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: ${spacing.majorScale(2)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-top: ${spacing.majorScale(6)}px;
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${spacing.majorScale(6)}px;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    > ${LeftColumn} {
      margin-right: ${spacing.majorScale(4)}px;
    }
  }
`

export const DirectorProfileContainer = styled.div`
  margin-top: -35px;
  padding-bottom: ${spacing.majorScale(3)}px;

  @media (min-width: ${breakpoints.lg}px) {
    max-width: 240px;
    margin-top: -50px;
  }
`

export const HeroContainer = styled.div`
  height: 250px;

  @media (min-width: ${breakpoints.lg}px) {
    height: 500px;
  }
`

export const TabGroupContainer = styled.div`
  margin-top: ${spacing.minorScale(2)}px;
  margin-bottom: ${spacing.majorScale(3)}px;
`

export const RequestInfoContainer = styled.div`
  display: relative;

  @media (max-width: ${breakpoints.lg}px) {
    padding: 0 ${spacing.majorScale(2)}px;
  }
`
